import { Box, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { HolidaysDataTable } from './components/HolidaysComponents/HolidaysDataTable';

interface MetricHolidaysProps {
  hideProjectSelector?: boolean;
}

export const MetricHolidays = ({ hideProjectSelector = false }: MetricHolidaysProps = {}) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();

  return (
    <Box
      sx={{ p: theme.spacing(6), display: 'flex', flexDirection: 'column', gap: theme.spacing(4) }}
    >
      {!hideProjectSelector && (
        <Box sx={{ mb: theme.spacing(12) }}>
          <Typography variant="h4">{formatMessage({ id: 'metrics.holidays.title' })}</Typography>
        </Box>
      )}
      <Box
        id="metrics-holidays-content"
        sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(4) }}
      >
        <Box>
          <HolidaysDataTable />
        </Box>
      </Box>
    </Box>
  );
};
